<template>
  <div class="tradetable">
    <p class="guowaip" style="margin-top:0">
      <a href="https://www.cnfirst.com.hk/" class="acom" target="_blank"
        >◆ CN First（中一期貨有限公司）</a
      >&nbsp;&nbsp;&nbsp; 香港证监会牌照代码：BBH027
    </p>
    <p class="guowaip" style="margin-top: 15px">
      <a href="https://apps.sfc.hk/publicregWeb/searchByName" target="_blank"
        >点击这里到中国香港证监会官网查询牌照情况</a
      >
    </p>
    <p class="guowaip">牌照查询标识：CN First</p>
  </div>
</template>

<script>
export default {};
</script>

<style scpoed>
.tradetable {
  width: 720px;
  margin: 0 auto;
}
.guowaip {
  height: 30px;
  line-height: 30px;
  letter-spacing: 1px;
}
.acom {
  color: black;
  text-decoration: none;
  margin-right: 35px;
}
.acom:hover {
  color: black;
}
</style>